export type FirebaseAuthErrorCode =
  | "auth/user-disabled"
  | "auth/user-not-found"
  | "auth/wrong-password"
  | "auth/too-many-requests"
  | "auth/email-already-exists";

export const firebaseErrorMessages: Record<FirebaseAuthErrorCode, string> = {
  "auth/user-disabled":
    "El usuario está deshabilitado. Por favor, chequee que sea el correcto o contacte a su vendedor.",
  "auth/user-not-found":
    "Este email no está registrado o presenta un error. Por favor, chequee que sea el correcto o contacte a su vendedor.",
  "auth/wrong-password":
    "La contraseña no es correcta. Por favor, chequee que sea la provista por su vendedor.",
  "auth/too-many-requests":
    "Demasiados intentos fallidos. Por favor, intenta de nuevo más tarde.",
  "auth/email-already-exists": "El email ingresado ya existe.",
};
